<template>
  <v-row class="editTextModalQuestionComponent">
    <v-col
      cols="12"
      md="9"
    >
      <v-text-field
        v-model="questionCopy.question"
        :counter="500"
        :rules="[
          ...Rules.requiredNamed('Question'),
          ...Rules.max(questionCopy.question, 500)
        ]"
        label="Question text"
        required
      />
    </v-col>
    <v-col
      cols="12"
      sm="6"
      md="3"
    >
      <v-autocomplete
        v-model="questionCopy.question_type"
        :items="types"
        item-text="name"
        :rules="Rules.requiredNamed('Question type')"
        label="Question Type"
        return-object
        required
      />
    </v-col>
    <v-col
      v-if="!questionCopy.question_type.needs_options"
      cols="12"
      sm="6"
    >
      <v-text-field
        v-model="questionCopy.placeholder"
        :counter="50"
        :maxlength="50"
        label="Placeholder"
        required
      />
    </v-col>
    <v-col
      v-else
      cols="12"
      sm="6"
    >
      <QuestionOptionsComponent
        :options="questionCopy.question_options"
        @newOption="updateOptions($event)"
      />
    </v-col>
    <v-col cols="12">
      <wysiwyg v-model="questionCopy.html" />
    </v-col>
    <v-col
      cols="12"
      md="9"
    >
      <v-switch
        v-model="includeDocuments"
        label="Include Document(s)"
      />
      <QuestionDocumentsEditComponent
        v-if="includeDocuments"
        :documents="questionCopy.question_documents"
        @newDocument="updateDocuments($event)"
      />
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'EditTextModalQuestionComponent',
  props: {
    question: {
      type: Object,
      default: () => {
        return {}
      }
    },
    types: {
      type: Array,
      default: () => {
        return {}
      }
    }
  },
  data: () => ({
    questionCopy: {
      question_type: {}
    },
    includeDocuments: false
  }),
  computed: {
    //
  },
  watch: {
    question (newQuestion, oldQuestion) {
      this.questionCopy = newQuestion
    }
  },
  created () {
    this.questionCopy = this.question
    this.questionCopy.selectedRules = this.question.rules ? this.question.rules : []
    this.includeDocuments = this.questionCopy.question_documents.length
  },
  methods: {
    updateDocuments (documents) {
      this.questionCopy.question_documents = documents
    }
  }
}
</script>
<style lang="scss">
.editTextQuestionComponent {
    //
}
</style>
